import { SoundResource } from 'client/model/resources';

import { routes } from '../../lib/routes';
import { SoundsListResult } from '../../types/utils';
import { callPublicApi } from '../utils';

export function getSkillSounds(skillId: string, page: number) {
    return callPublicApi<SoundsListResult>({
        method: 'GET',
        url: routes.app.appStoreApi(`public/v1/apps/${skillId}/sounds?page=${page}`),
    }).then((x) => ({
        items: x.sounds,
        total: x.total,
        limit: x.limit,
    }));
}

export function deleteSkillSound(skillId: string, soundId: string) {
    return callPublicApi({
        method: 'DELETE',
        url: routes.app.appStoreApi(`public/v1/apps/${skillId}/sounds/${soundId}`),
    });
}

export function uploadSkillSound(skillId: string, file: File) {
    const form = new FormData();
    form.append('file', file);

    return callPublicApi<{ sound: SoundResource }>({
        method: 'POST',
        url: routes.app.appStoreApi(`public/v1/apps/${skillId}/sounds`),
        data: form,
    }).then((x) => x.sound);
}

export function getSkillSound(skillId: string, soundId: string) {
    return callPublicApi<{ sound: SoundResource }>({
        method: 'GET',
        url: routes.app.appStoreApi(`public/v1/apps/${skillId}/sounds/${soundId}`),
    }).then((x) => x.sound);
}
